import {
  EChartTimeFormat,
  TChartTimeFormatTranslation,
} from './select-chart-time-format.ts';

const chartTimeFormats: TChartTimeFormatTranslation = {
  [EChartTimeFormat.COMPACT]: {
    displayName: 'Kompaktný',
    details: 'Zobrazuje iba čas pre časové rozsahy kratšie ako 24 hodín',
  },
  [EChartTimeFormat.DETAILED]: {
    displayName: 'Podrobný',
    details: 'Vždy zobrazuje úplný dátum',
  },
};

export default {
  placeholder: 'Vybrať formát času grafu',
  chartTimeFormats,
};
